import { createIcon } from '@chakra-ui/react';

export const StatsSyncingIcon = createIcon({
  displayName: 'StatsSyncingIcon',
  viewBox: '0 0 48 48.5',
  defaultProps: {
    fill: 'none',
    height: '48.5',
    width: '48',
  },
  path: (
    <>
      <circle cx="24" cy="24" r="24" fill="#F0F4F8" />
      <path
        d="M19 26H13V32M13 26L17.64 30.36C18.7147 31.4353 20.0444 32.2208 21.5048 32.6432C22.9652 33.0657 24.5089 33.1112 25.9917 32.7757C27.4745 32.4402 28.8482 31.7346 29.9845 30.7246C31.1209 29.7146 31.9828 28.4332 32.49 27M29 22H35V16M35 22L30.36 17.64C29.2853 16.5647 27.9556 15.7792 26.4952 15.3568C25.0348 14.9343 23.4911 14.8888 22.0083 15.2243C20.5255 15.5598 19.1518 16.2654 18.0155 17.2754C16.8791 18.2854 16.0172 19.5668 15.51 21"
        stroke="#829AB1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
